module.exports = __webpack_public_path__ + "static/media/a6.8b5e4aa4.jpg";